import { render, staticRenderFns } from "./ImportHistoriesTable.vue?vue&type=template&id=46b2540e&scoped=true"
import script from "./ImportHistoriesTable.vue?vue&type=script&lang=js"
export * from "./ImportHistoriesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b2540e",
  null
  
)

export default component.exports